import { render, staticRenderFns } from "./ChatSearch.vue?vue&type=template&id=13872bb0&scoped=true&"
import script from "./ChatSearch.vue?vue&type=script&lang=js&"
export * from "./ChatSearch.vue?vue&type=script&lang=js&"
import style0 from "./ChatSearch.scss?vue&type=style&index=0&id=13872bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13872bb0",
  null
  
)

export default component.exports